// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 15) return "static/js/5f7d538a2cd7249556cc.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"79e1b619d2e11ace98be","116":"95290d6c7e5b04600724","117":"4c4fd9620105a7318119"}[chunkId] + ".chunk.js";
};